/** App Configuration Object */
let config = {
    lisenced: false,
    lisencee: null,
    productType: 'demo',
    registrationDate: null,
    serial: null,
    expiryDate: null,
    expired: false,
    gst: {
        enabled: false,
        GSTRate: 0,
        inclusive: false,
    },
    scheduledBackup: {
        enabled: false,
        duration: (1000 * 60 * 60) // 1hr
    },
};

/** Check & Initailize Configuration */
const configApp = () => {
    let configuration = localStorage.getItem('config')
    if (!configuration) {
        localStorage.setItem("config", JSON.stringify(config));
    }
    let currentConfig = JSON.parse(configuration)
    console.log(currentConfig);
};

/** Change Configuration Object */
export const setConfig = (configure) => {
    // console.log(configure);
    localStorage.setItem('config', JSON.stringify(configure))
}

/** Get the Configuration Object */
export const getConfig = () => {
    let c = localStorage.getItem('config')
    return JSON.parse(c)
}

export default configApp